<div class="header-organization-divider"></div>
<div class="header-organization" fxHide.lt-sm>{{ perifereia }}</div>